import React, {FC, memo} from "react";
import {RandomButton, RandomIcon} from "./ButtonRandomize-styles";
import {ButtonRandomizeProps} from "./ButtonRandomize-types";

const ButtonRandomize: FC<ButtonRandomizeProps> = memo((props) => {
    const {title, onClick} = props;

    return (
        <RandomButton title={title} onClick={onClick}>
            <RandomIcon/>
        </RandomButton>
    );
});

export default ButtonRandomize;
